import { MixerHorizontalIcon, StackIcon } from '@radix-ui/react-icons';
import { Flex, TabNav } from '@radix-ui/themes';
import { useLocation, useNavigate } from 'react-router-dom';
import { paths } from 'routes/paths';

/** all @radix-ui/react-icons share this component signature */
type RadixIcon = typeof MixerHorizontalIcon;

interface IPlatformConsoleTab {
  label: string;
  to: string;
  icon: RadixIcon;
}

const TABS: IPlatformConsoleTab[] = [
  {
    label: 'Feature Flags',
    to: paths.platformConsole.featureFlags,
    icon: MixerHorizontalIcon,
  },
  {
    label: 'Jobs',
    to: paths.platformConsole.jobs,
    icon: StackIcon,
  },
];

export const PlatformConsoleNav = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <TabNav.Root size="2">
      {TABS.map((tab) => {
        const Icon = tab.icon;

        return (
          <TabNav.Link
            key={tab.to}
            active={pathname.startsWith(tab.to)}
            onClick={() => navigate(tab.to)}
          >
            <Flex align="center" gap="2">
              <Icon />
              {tab.label}
            </Flex>
          </TabNav.Link>
        );
      })}
    </TabNav.Root>
  );
};
